import { useDevice } from '@bpba/ui-components';
/** Hook para obtener el texto placeholder según la pantalla actual*/
export function usePlaceholder(placeholders: string[]) {
  const device = useDevice();

  if (placeholders === undefined) return '';

  if (device === 'mobile') {
    return placeholders[0];
  } else if (placeholders.length > 1) {
    return placeholders[1];
  }
}
